import { Tag } from "@app/types/Cue";

export const myBTRecommendedKeywords: Tag[] = [
  {
    name: "Property",
    urlPath: "/keywords/property",
  },
  {
    name: "The Level Ground",
    urlPath: "/keywords/level-ground",
  },
  {
    name: "Daily Debrief",
    urlPath: "/keywords/daily-debrief",
  },
  {
    name: "IPO",
    urlPath: "/keywords/ipo",
  },
  {
    name: "Stocks to watch",
    urlPath: "/keywords/stocks-watch",
  },
  {
    name: "Singapore Airlines",
    urlPath: "/keywords/singapore-airlines",
  },
  {
    name: "Malaysia",
    urlPath: "/keywords/malaysia",
  },
  {
    name: "Wealth Management",
    urlPath: "/keywords/wealth-management",
  },
] as Tag[];

export const myBTRegionsKeywords: Tag[] = [
  {
    name: "China",
    urlPath: "/keywords/china",
  },
  {
    name: "Malaysia",
    urlPath: "/keywords/malaysia",
  },
  {
    name: "Asean",
    urlPath: "/keywords/asean",
  },
  {
    name: "United States",
    urlPath: "/keywords/united-states",
  },
  {
    name: "Vietnam",
    urlPath: "/keywords/vietnam",
  },
  {
    name: "Japan",
    urlPath: "/keywords/japan",
  },
  {
    name: "Indonesia",
    urlPath: "/keywords/indonesia",
  },
  {
    name: "Hong Kong",
    urlPath: "/keywords/hong-kong",
  },
  {
    name: "India",
    urlPath: "/keywords/india",
  },
  {
    name: "Thailand",
    urlPath: "/keywords/thailand",
  },
] as Tag[];

export const myBTStocksKeywords: Tag[] = [
  {
    name: "Singapore Stocks",
    urlPath: "/keywords/singapore-stocks",
  },
  {
    name: "China stocks",
    urlPath: "/keywords/china-stocks",
  },
  {
    name: "Hong Kong stocks",
    urlPath: "/keywords/hong-kong-stocks",
  },
  {
    name: "Europe Stocks",
    urlPath: "/keywords/europe-stocks",
  },
  {
    name: "Japan stocks",
    urlPath: "/keywords/japan-stocks",
  },
  {
    name: "Malaysia stocks",
    urlPath: "/keywords/malaysia-stocks",
  },
  {
    name: "Australia/New Zealand stocks",
    urlPath: "/keywords/australianew-zealand-stocks",
  },
  {
    name: "US stocks",
    urlPath: "/keywords/us-stocks",
  },
  {
    name: "Straits Times Index",
    urlPath: "/keywords/straits-times-index",
  },
  {
    name: "Indonesia",
    urlPath: "/keywords/indonesia",
  },
] as Tag[];

export const myBTTagsDefinedList: {
  name: "recommended" | "stocks" | "regions";
  label: string;
  tags: Tag[];
}[] = [
  {
    name: "recommended",
    label: "Recommended",
    tags: myBTRecommendedKeywords,
  },
  {
    name: "stocks",
    label: "Stocks",
    tags: myBTStocksKeywords,
  },
  {
    name: "regions",
    label: "Region",
    tags: myBTRegionsKeywords,
  },
];
